import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../app-config/factories/window.factory';

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    constructor(@Inject(WINDOW) private window: Window) {}

    setCategory(category: string): void {
        this.setProperty('category', category);
    }

    setUserId(userId: string): void {
        this.setProperty('userId', userId);
    }

    fireEvent(eventName: string, data = ''): void {
        this.window.dataLayer.push({
            customEventData: data,
            customEventName: eventName,
            event: 'rdcCustomEvent',
        });
    }

    private setProperty(propertyName: string, value: string): void {
        this.window.dataLayer.push({
            [propertyName]: value,
        });
    }
}
